const en = {
  appName: "Buoy X",
  signIn: "Sign in",
  createAccount: "Create account",
  email: "Email",
  password: "Password",
  name: "Name",
  continueGoogle: "Continue with Google",
  continueApple: "Continue with Apple",
  signOut: "Sign out",
  fleet: "My buoys",
  allBuoys: "All buoys",
  users: "Users",
  account: "Account",
  addBuoy: "Add buoy",
  online: "Online",
  sleep: "Sleep",
  offline: "Offline",
  lastSeen: "Last seen",
  battery: "Battery",
  signal: "LTE signal",
  control: "Control",
  map: "Map",
  status: "Status",
  settings: "Settings",
  noBuoys: "No buoys yet",
  noBuoysHint:
    "Scan the QR supplied with your buoy or enter its serial and claim code.",
  serial: "Serial",
  claimCode: "Claim code",
  scanQr: "Scan QR",
  claim: "Add buoy",
  theme: "Appearance",
  system: "System",
  light: "Light",
  dark: "Dark",
  gpsLocation: "Get GPS location",
  refresh: "Refresh status",
  powerOff: "Power off",
  recentCommands: "Recent commands",
  verifiedHint: "Check your inbox and verify your email before adding a buoy.",
  back: "Back to fleet",
  mapUnavailable: "Waiting for a GPS position",
  factory: "Factory",
  factoryTitle: "Flash a buoy",
  factoryIntro:
    "Set the serial, connect USB and flash. Uploads are verified before the buoy checks in.",
  factorySetup: "Device setup",
  factoryDesktop:
    "Use desktop Chrome or Edge over HTTPS. USB flashing is not available in mobile apps or this browser.",
  factoryUnavailable: "Factory packaging is not configured on this server yet.",
  factoryLoading: "Loading approved firmware…",
  factoryConnect: "Connect USB device",
  factoryConnected: "USB connected",
  factoryDisconnect: "Disconnect USB",
  factoryUsbHint:
    "Close Arduino IDE and serial monitors. Connect the powered board with a data cable. SIM and modem identity are read from RAM before anything is erased. If detection fails, hold BOOT during connection.",
  factorySafety:
    "Keep actuators disconnected or safely restrained. Flashing resets the board and runs its existing hardware behavior. No movement commands are sent by this tool.",
  factoryOperation: "Operation",
  factoryProvision: "Initial setup",
  factoryUpdate: "Firmware update — preserve configuration",
  factoryReplace: "Replace MQTT credentials — recovery",
  factoryProvisionHint:
    "Initial setup replaces all firmware and settings on this USB board, including Arduino test firmware.",
  factoryReinstallHint:
    "Initial setup permanently deletes the previous buoy, ownership, telemetry, credentials and claim data. It creates a new identity and claim QR, then erases the whole flash and installs a fresh configuration.",
  factoryUpdateHint:
    "Updates preserve LittleFS config and NVS. Partition layouts must match. The app0 image and OTA boot selection are updated; no remote OTA is used.",
  factoryReplaceHint:
    "This rotates the existing MQTT password immediately and replaces its config filesystem. Ownership stays unchanged. An unowned buoy gets a new claim QR.",
  factoryInitializeRecoveryHint:
    "This board has not completed setup. Recovery replaces its firmware and settings and keeps its assigned serial.",
  factoryReplaceConsent:
    "I understand existing device credentials will stop working and this board must be reflashed.",
  factoryInitialConsent:
    "I understand this permanently deletes the existing buoy and all of its server and device data, then creates a new serial, identity and credentials.",
  factoryRelease: "Approved firmware release",
  factoryBusy: "Working…",
  factoryFlash: "Flash device",
  factoryReport: "Finish USB upload",
  factoryReady: "USB flash verified — setup ready",
  factoryClaimReady: "Claim details ready",
  factoryMqttWaiting: "Waiting for the buoy’s first MQTT connection…",
  factoryMqttConnected: "Buoy connected to MQTT",
  factoryClaimHint:
    "Save the QR, serial and claim code now. You can finish setup while the buoy connects.",
  factoryClaimQrAlt: "Buoy claim QR code",
  factoryClaimQrLoading: "Generating claim QR…",
  factoryCompleted: "Provisioning complete",
  factoryDownloadFinish: "Download claim QR & finish",
  factoryFinish: "Finish setup",
  factoryError: "Factory operation failed",
  factorySerialHint:
    "The next available serial is filled in automatically. You can change it before flashing.",
  factoryNewSerial:
    "Initial setup requires a new serial. The next available value is filled in automatically.",
  factoryExistingSerial: "This USB board keeps its assigned serial.",
  factoryChip: "Chip",
  factoryMac: "USB chip MAC",
  factorySimStatus: "SIM status",
  factorySimIccid: "SIM ICCID",
  factorySimImsi: "SIM IMSI",
  factoryModemImei: "Modem IMEI",
  factorySimProvider: "SIM provider",
  factorySimNumber: "SIM phone number",
  factorySimNetwork: "Current network",
  factoryProgress: "Flash progress",
  factoryUnsupportedChip:
    "Only the approved classic ESP32 with 4 MB flash is supported.",
  factoryWrongDevice:
    "This setup belongs to a different USB device. Reconnect the correct board.",
  factoryPartitions:
    "The board’s partition layout is incompatible. No update was written.",
  factoryChecksum:
    "Artifact verification failed. No unverified image will be flashed.",
  factoryExpired:
    "The setup expired. Reconnect the USB board to recover its credentials.",
  factoryDeviceDetection:
    "USB detection failed. Check the cable, USB driver and BOOT button; close other serial tools.",
  factoryFlashFailed:
    "USB upload failed. Check the connection and retry this board.",
  factoryInUse:
    "This serial or USB board is already registered. Connect the same board to continue setup, or use update/recovery for its assigned serial.",
  factoryActiveJob:
    "Another administrator is already setting up this buoy. Wait for them to finish.",
  factoryRetired:
    "This buoy is retired. Use Initial setup to erase it and create a new identity.",
  factorySetupChanged:
    "The board already has an assigned serial. Review the restored setup and try again.",
  factoryWorkerDown:
    "Firmware packaging is unavailable. Restore the service, then retry this board.",
  factorySimProbeFailed:
    "The pre-flash SIM check did not finish. Reconnect the powered board and try again.",
  factoryModemNotFound:
    "The A7670 modem did not answer before flashing. Check board power and modem wiring.",
  factorySimIdentityUnavailable:
    "The modem answered, but its SIM ICCID or modem IMEI could not be read. Nothing was erased.",
  factorySimNotReady:
    "The SIM is not ready. Remove its PIN lock or correct the SIM problem before flashing.",
  factorySimAssigned:
    "This SIM ICCID is already assigned to another buoy. Check which physical SIM is installed.",
  factoryModemAssigned:
    "This modem IMEI is already assigned to another buoy. Check the connected hardware.",
  factorySimChanged:
    "The SIM or modem no longer matches this pending setup. Start a new setup for the connected hardware.",
} as const;

export type TranslationKey = keyof typeof en;
export const t = (key: TranslationKey) => en[key];
